
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { MfaFactor } from '../types';

interface MfaStateContextType {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  isMfaRequired: boolean;
  setIsMfaRequired: (isMfaRequired: boolean) => void;
  factorId: string | null;
  setFactorId: (factorId: string | null) => void;
  challengeId: string | null;
  setChallengeId: (challengeId: string | null) => void;
  enrolledFactors: MfaFactor[];
  setEnrolledFactors: (enrolledFactors: MfaFactor[]) => void;
  resetMfaState: () => void;
}

const MfaStateContext = createContext<MfaStateContextType | undefined>(undefined);

export function MfaStateProvider({ children }: { children: ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isMfaRequired, setIsMfaRequired] = useState(false);
  const [factorId, setFactorId] = useState<string | null>(null);
  const [challengeId, setChallengeId] = useState<string | null>(null);
  const [enrolledFactors, setEnrolledFactors] = useState<MfaFactor[]>([]);

  const resetMfaState = () => {
    setIsMfaRequired(false);
    setFactorId(null);
    setChallengeId(null);
  };

  const value = {
    isLoading,
    setIsLoading,
    isMfaRequired,
    setIsMfaRequired,
    factorId,
    setFactorId,
    challengeId,
    setChallengeId,
    enrolledFactors,
    setEnrolledFactors,
    resetMfaState
  };

  return (
    <MfaStateContext.Provider value={value}>
      {children}
    </MfaStateContext.Provider>
  );
}

export function useMfaStateContext() {
  const context = useContext(MfaStateContext);
  if (context === undefined) {
    throw new Error('useMfaStateContext must be used within a MfaStateProvider');
  }
  return context;
}
